import React from 'react';
import Map from './Map';
import { AreaTypeGeoFences, AreaTypeNoFlyZones } from './AreaType';
import PlaceMarker from './PlaceMarker';
import { Palette } from './Palette';
function AreaMap({ apiKey, areaContainer, areaType, editable = false, onMarkerDragEnd }) {
    const [markerCoords, setMarkerCoords] = React.useState();
    const handleDragEnd = (key, coords) => onMarkerDragEnd(parseInt(key), coords);
    React.useEffect(() => {
        setMarkerCoords(areaContainer.area
            ?.at(0)
            ?.slice(0, -1) // Hide the last one which should be the same as the first one.
            ?.map((e) => ({ lat: e[1], lng: e[0] })));
    }, [areaContainer]);
    return (React.createElement(Map, { apiKey: apiKey, geoFences: areaType === AreaTypeGeoFences ? [areaContainer] : undefined, noFlyZones: areaType === AreaTypeNoFlyZones ? [areaContainer] : undefined, locked: !editable, hideAreaCenter: true, draggable: true }, markerCoords?.map((e, i) => (React.createElement(PlaceMarker, { key: i, label: {
            text: (i + 1).toString(),
            color: 'white',
            fontWeight: 'bold',
        }, position: e, draggable: editable, color: areaType === AreaTypeGeoFences
            ? Palette.GeoFenceMarker
            : areaType === AreaTypeNoFlyZones
                ? Palette.NoFlyZoneMarker
                : Palette.WaypointMarker, onDragEnd: (coords) => handleDragEnd(i.toString(), coords) })))));
}
export default React.memo(AreaMap);
